import { render } from "./App.vue?vue&type=template&id=9d54fb7a&scoped=true&ts=true"
import script from "./App.ts?vue&type=script&lang=ts&external"
export * from "./App.ts?vue&type=script&lang=ts&external"

import "./App.vue?vue&type=style&index=0&id=9d54fb7a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d54fb7a"]])

export default __exports__